/*eslint-disable*/
import React, { useState } from "react";
//import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@mui/styles";
import { Grid } from "@mui/material";
/*import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";*/
// core components

import FrequentQuestions from "views/dialog/FrequentQuestions";

import { cardBodyStyle } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function Footer(props) {
  const classes = useStyles();

  const [openFrequentQuestion, setOpenFrequentQuestion] = useState(false);

  const handleCloseFrequentQuestion = () => {
    setOpenFrequentQuestion(false); // Close the modal
  };

  return (
    <div className={classes.footer3}>
      <center>
        <Grid container>
          <Grid item xs={12} sm={12}>
            <p className={classes.right}>
              <span
                onClick={() => setOpenFrequentQuestion(true)}
                style={{
                  fontSize: 12,
                  textTransform: "none",
                  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                  fontWeight: 500,
                  lineHeight: 1.75,
                  color: "#000",
                  cursor: "pointer",
                  border: "1px solid dimgrey",
                  padding: "4px 10px",
                  borderRadius: 4,
                  marginRight: 8,
                }}
              >
                Terminos y condiciones - Políticas de protección de datos -
                Preguntas frecuentes
              </span>{" "}
              <span>
                &copy; {1900 + new Date().getYear()}{" "}
                {/*<a href="#" target="_blank" className={classes.a}>
            Palankas
          </a>*/}
                Panel de control.
              </span>
            </p>
          </Grid>
        </Grid>
      </center>
      {openFrequentQuestion && (
        <FrequentQuestions
          open={openFrequentQuestion}
          exit={handleCloseFrequentQuestion}
        />
      )}
    </div>
  );
}
